import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { HotToastService } from '@ngneat/hot-toast';
import { BusinessAccountWithChildrenDto, InvoiceDetailDto } from 'src/app/core/dtos/dto';
import { HttpErrorResponseMessages } from 'src/app/core/dtos/http-error-response-messages';
import { AccountService } from 'src/app/core/services/account.service';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';

@Component({
  selector: 'app-invoices',
  templateUrl: './invoices.component.html',
  styleUrls: ['./invoices.component.scss']
})
export class InvoicesComponent implements OnInit {
  businessAccount: BusinessAccountWithChildrenDto;
  downloadReadyLink: string;
  invoices: InvoiceDetailDto[];
  pdfName: string;

  @ViewChild('downloadModal') downloadModal: ModalComponent;

  constructor(
    private accountService: AccountService,
    private toastService: HotToastService,
  ) { }

  ngOnInit(): void {
    this.setBusinessAccount();
  }

  setBusinessAccount() {
    this.accountService.getBusinessAccount().subscribe(
      result => {
        this.businessAccount = result.content;
        this.getInvoices(this.businessAccount.info.id);
      },
      (error: HttpErrorResponse) => {
        if (error.status === 400) {
          const errorMessage = error.error as HttpErrorResponseMessages;
          errorMessage.reasons.forEach(reasons => {
            this.toastService.warning(reasons.errorMessage);
          });
        }
      });
  }

  downloadInvoice(invoiceId: number) {
    this.accountService.getInvoicePdfNameById(invoiceId).subscribe(
      result => {
        this.pdfName = result.content;
        this.downloadReadyLink = result.content;
        this.downloadModal.open();
      },
      (error: HttpErrorResponse) => {
        if (error.status === 400) {
          const errorMessage = error.error as HttpErrorResponseMessages;
          errorMessage.reasons.forEach(reasons => {
            this.toastService.warning(reasons.errorMessage);
          });
        }
      });
  }
  getInvoices(businessId: number) {
    this.accountService.getInvoicesDetailByBusinessId(businessId).subscribe(
      result => {
        this.invoices = result.content;

      },
      (error: HttpErrorResponse) => {
        if (error.status === 400) {
          const errorMessage = error.error as HttpErrorResponseMessages;
          errorMessage.reasons.forEach(reasons => {
            this.toastService.warning(reasons.errorMessage);
          });
        }
      });
  }

  generateInvoiceFile(pdfName: string) {
    if (pdfName == null) {
      return;
    }
    this.accountService.downloadInvoicePdf(pdfName).subscribe(
      result => {
        const newBlob = new Blob([result], { type: "application/pdf" });
        const downloadURL = window.URL.createObjectURL(newBlob);
        const link = document.createElement('a');
        link.href = downloadURL;
        link.download = pdfName;
        link.click();
      },
      (error: HttpErrorResponse) => {
        if (error.status === 400) {
          const errorMessage = error.error as HttpErrorResponseMessages;
          errorMessage.reasons.forEach(reasons => {
            this.toastService.warning(reasons.errorMessage);
          });
        }
      });
  }
}
